import { QueryExecution } from '../types';
import { html, TemplateResult } from 'lit';
import { GzLinkWebComponent } from '../../../ui/gzLinkComponent';
import { LinkColor } from '../../../ui/gzLinkComponent/types';
import { getRequestDefaultOptions } from '../../../utils/request.utils';

export function isQueryExecutionFinished(queryExecution: QueryExecution): boolean {
  return (
    queryExecution !== undefined &&
    (queryExecution.hasExpiredResults ||
      !queryExecution.doNotStoreResultsAfterTimestamp ||
      Date.now() / 1000 > queryExecution.doNotStoreResultsAfterTimestamp ||
      (queryExecution.endpointsStatistics !== undefined &&
        queryExecution.endpointsStatistics.totalCount ===
          queryExecution.endpointsStatistics.withDeliveredResultsCount +
            queryExecution.endpointsStatistics.withDeliveryErrorCount +
            queryExecution.endpointsStatistics.withDismissedResultsCount +
            queryExecution.endpointsStatistics.withFailedSessionStartCount))
  );
}

export function generateEndpointLink(data: any): GzLinkWebComponent {
  const endpointLink = new GzLinkWebComponent();

  endpointLink.callback = sendEndpointShowEventFromGrid.bind(this, data.item.endpointId);
  endpointLink.color = LinkColor.PRIMARY;
  endpointLink.innerText = data.item.endpoint;

  return endpointLink;
}

function sendEndpointShowEventFromGrid(endpointId: number): void {
  this.dependencies.api.clients.GetEndpointsDetails.openEndpointDetails(endpointId, getRequestDefaultOptions());
}

export function convertNumberToHtmlSpanWithSecondaryFont(value?: any): TemplateResult | undefined {
  return !isNaN(value) ? html`<span class="number">${value}</span>` : value;
}
